export interface SyncStatus {
  id: string;
  itemsCount: number;
  state: string;
  summary: {
    totalCasesCount: number;
    newCasesCount?: number;
    registeredCasesCount: number;
    integrationCasesCount?: number;
    integratedCasesCount?: number;
    errorCasesCount: number;
  };
}

export interface IBatchGroupSummary {
  error: number;
  successful: number;
  total: number;
  processedCases: number;
}

export class BatchGroupSummary implements IBatchGroupSummary {
  constructor(
    public error: number = 0,
    public successful: number = 0,
    public total: number = 0,
    public processedCases: number = 0
  ) {}
}
